export default __webpack_public_path__ + "static/media/google.93021da1.png";